/**
 * Whether a static page href stays inside the site: root-relative paths and
 * in-document hashes. Protocol-relative (`//host`) and absolute URLs are external.
 *
 * @param href - Link target from page JSON
 */
function isInternalStaticHref(href: string): boolean {
  return (href.startsWith('/') && !href.startsWith('//')) || href.startsWith('#');
}

/**
 * Link attributes for a static page href: none for internal links, and a new tab
 * without a referrer for external ones.
 *
 * @param href - Link target from page JSON
 */
function toStaticLinkTargetProps(href: string): { target?: '_blank'; rel?: 'noreferrer' } {
  return isInternalStaticHref(href) ? {} : { target: '_blank', rel: 'noreferrer' };
}

export { isInternalStaticHref, toStaticLinkTargetProps };
